/**
 * `/sales/proformas/<id>` — proforma detail + lifecycle actions (ADR-0032).
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { ProformaDetailPage } from "../../../../features/proformas/index.ts";
import "../../../../features/invoices/detail/invoice-detail.css";

export const Route = createFileRoute("/(workspace)/sales/proformas/$proformaId/")({
  component: ProformaDetailRoute,
});

function ProformaDetailRoute() {
  const { proformaId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Sales" },
        { label: "Proformas", to: "/sales/proformas" },
        { label: "Detail" },
      ]}
      // Match invoice details: the page owns the sticky header/footer and
      // constrains only the document stage via page-scoped CSS.
      viewportClassName="p-0 md:p-0"
      contentClassName="max-w-none"
    >
      <ProformaDetailPage proformaId={proformaId} />
    </WorkspaceShell>
  );
}
